import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Timeline from 'components/Timeline'
import PlanTimelineBlock from 'workspace/PlanTimelineBlock'
import { selectNavigationRange } from 'containers/Navigation/selectors'

const PlanTimeline = ({
  id,
  date,
  scope,
  symbol,
  scheduleIds,
  isLoading,
  lunchBreaks,
  start,
  finish
}) => (
  <Timeline
    scope={scope}
    date={date}
    header={symbol}
    isLoading={isLoading}
    lunchBreaks={lunchBreaks}
    start={start}
    finish={finish}
  >
    {scheduleIds.map(sid => (
      <PlanTimelineBlock key={sid} id={sid} />
    ))}
  </Timeline>
)

PlanTimeline.propTypes = {
  id: PropTypes.number.isRequired,
  symbol: PropTypes.string.isRequired,
  date: PropTypes.object.isRequired,
  scope: PropTypes.oneOf(['day', 'week', 'range']).isRequired,
  scheduleIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  lunchBreaks: PropTypes.arrayOf(
    PropTypes.shape({
      startsAfterMidnight: PropTypes.number.isRequired,
      duration: PropTypes.number.isRequired
    })
  ),
  isLoading: PropTypes.bool,
  start: PropTypes.object,
  finish: PropTypes.object
}

const mapStateToProps = (state, { id }) => ({
  date: selectNavigationRange(state).from,
  scope: state.navigation.shift ? 'range' : state.navigation.scope,
  start: state.navigation.shift ? selectNavigationRange(state).from : undefined,
  finish: state.navigation.shift ? selectNavigationRange(state).to : undefined,
  ...state.locations.allById[id],
  scheduleIds: state.schedules.idsByLocation[id],
  isLoading: state.locations.isLoadingSchedulesById[id]
})

export default connect(mapStateToProps)(PlanTimeline)
